export const CONTACT = 'CONTACT';
export const QUOTATION = 'QUOTATION';
